import { LazyIssueApp } from '@jira/issue__lazy-app/src/LazyIssueApp.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdContent } from '@jira/navigation-apps__constants/src/SidebarIdContent.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { softwareCapacityClassicRoute } from '@jira/router-routes__classic-projects-routes/src/softwareCapacityClassicRoute.tsx';
import { classicSoftwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { projectThemeResource } from '@jira/router-resources__project-theme/src/projectThemeResource.tsx';
import { CapacitySkeleton } from '@jira/platform__skeletons/src/ui/capacity/CapacitySkeleton.tsx';
import { softwareCapacityRouteEntry } from './ui/software/capacity/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareCapacityClassicRouteEntry: Route = createEntry(
	softwareCapacityClassicRoute,
	() => ({
		afterPaint: [LazyIssueApp],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
		// eslint-disable-next-line no-restricted-syntax
		component: CapacitySkeleton,
		entryPoint: () => {
			if (__SERVER__) {
				return undefined;
			}
			return softwareCapacityRouteEntry;
		},
		forPaint: [LazyAtlassianNavigation],
		group: 'classic-software',
		layout: classicSoftwareProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
			sidebarId: SidebarIdContent,
		},
		resources: [
			...getIssueViewResources(),
			...getNavigationResources(), // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			projectThemeResource,
		],
		skeleton: CapacitySkeleton,
		supportsPreviewPanel: true,
		supportsProjectTheme: 'contoured',
		ufoName: 'classic-capacity',
	}),
);
